<template>
  <div class="register-form-parent">
    <div class="form-wrapper">
      <p class="form-p-1">{{ content.header }}</p>
      <form      
        class="register-form"
        @submit="handleSubmit" 
        v-if="!success && !error"       
      >        
        <div class="inputs">

          <label :class="['input', form.errors.name && 'error']" v-if="content.inputs.includes('first')">
            <input v-model.trim="form.data.name.value" autocomplete="on" type="text" placeholder="* First name:" />
            <div class="error-text">{{ form.errors.name }}</div>
          </label>

          <label :class="['input', form.errors.lastname && 'error']" v-if="content.inputs.includes('last')">
            <input v-model.trim="form.data.lastname.value" autocomplete="on" type="text" placeholder="* Last name:" />
            <div class="error-text">{{ form.errors.lastname }}</div>
          </label>

          <label :class="['input', form.errors.email && 'error']" v-if="content.inputs.includes('email')">
            <input v-model.trim="form.data.email.value" autocomplete="on" type="text" placeholder="* Email:" />
            <div class="error-text">{{ form.errors.email }}</div>
          </label>

          <label :class="['input', form.errors.company && 'error']" v-if="content.inputs.includes('company')">
            <input v-model="form.data.company.value" autocomplete="on" type="text" placeholder="* Company:" />
            <div class="error-text">{{ form.errors.company }}</div>
          </label>

          <label :class="['input', form.errors.title && 'error']" v-if="content.inputs.includes('title')">
            <input v-model="form.data.title.value" autocomplete="on" type="text" placeholder="* Job title:" />
            <div class="error-text">{{ form.errors.title }}</div>
          </label>

          <label :class="['input', form.errors.country && 'error']" v-if="content.inputs.includes('country')">
            <input v-model="form.data.country.value" autocomplete="on" type="text" placeholder="* Country:" />
            <div class="error-text">{{ form.errors.country }}</div>
          </label>
          
          <label :class="['input', form.errors.nemployees && 'error']" v-if="content.inputs.includes('number')">
            <input v-model="form.data.nemployees.value" autocomplete="on" type="text" placeholder="Estimated Number of Employees:" />
            <div class="error-text">{{ form.errors.nemployees }}</div>
          </label>
          
        </div>

        <p class="small-notice">
          Yacht Interior Society C.V. is committed to protecting and respecting your privacy, and we’ll only use your 
          personal information to administer your account and to provide the information about the Sustainability 
          in Yacht Interior Design. From time to time, we would like to contact you about our products and services, 
          as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, 
          please tick below to say how you would like us to contact you:
        </p>
        <div :class="['checkbox-wrapper', form.errors.checkbox && 'error']">
          <div class="input-checkbox">
            <input type="checkbox" id="check"/>
            <label for="check" style="--d: 20px;">
              <svg viewBox="0,0,50,50">
                <path d="M5 30 L 20 45 L 45 5"></path>
              </svg>
            </label>            
          </div>
          <p >
            I agree to receive other communications from Yacht Interior Society C.V.
          </p>
          <div class="error-text">{{ form.errors.checkbox }}</div>          
        </div>
        <p class="small-notice">
          You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, 
          and how we are committed to protecting and respecting your privacy, please review 
          our <router-link to="/privacy-policy/">Privacy Policy</router-link>.
        </p>
        <p class="small-notice">
          By clicking submit below, you consent to allow Yacht Interior Society C.V. to store and process 
          the personal information submitted above to provide you the content requested.
        </p>

        <div class="submit-input">
          <input type="submit" :value="content.button" />
        </div>
      </form>
      <div class="webinar-info-text" v-if="success">
        <div class="info">Please, check your email box.</div>
      </div>
      <div class="webinar-info-text error" v-if="error">
        <div class="info">{{error}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "register_form",
  props: {
    content: Object
  },
  data: () => ({
    success: false,
    error: false,
    form: {
      isSend: false,
      isSentCorrectly: false,
      isSentWrong: false,
      data: {
        name: {
          required: true,
          value: ""
        },
        lastname: {
          required: true,
          value: ""
        },
        email: {
          required: true,
          value: ""
        },
        company: {
          required: true,
          value: ""
        },      
        title: {
          required: true,
          value: ""
        },
        country: {
          required: true,
          value: ""
        },
        nemployees: {
          required: false,
          value: ""
        },
        checkbox: {
          required: false,
          value: "no"
        }
      },
      errors: {
        name: null,
        lastname: null,
        email: null,
        company: null,        
        title: null,
        country: null,
        nemployees: null,
        checkbox: null
      }
    }   
  }),
  created() {
    // console.log(this.content.inputs)
    // console.log(!this.content.inputs.includes('first'))
    if(!this.content.inputs.includes('first')){
      this.form.data.name.required = false;
    }
    // console.log(!this.content.inputs.includes('last'))
    if(!this.content.inputs.includes('last')){
      this.form.data.lastname.required = false;
    }
    // console.log(!this.content.inputs.includes('email'))
    if(!this.content.inputs.includes('email')){
      this.form.data.email.required = false;
    }
    // console.log(!this.content.inputs.includes('company'))
    if(!this.content.inputs.includes('company')){
      this.form.data.company.required = false;
    }
    // console.log(!this.content.inputs.includes('country'))
    if(!this.content.inputs.includes('country')){
      this.form.data.country.required = false;
    }
    // console.log(!this.content.inputs.includes('title'))
    if(!this.content.inputs.includes('title')){
      this.form.data.title.required = false;
    }
  },
  methods: {  
    async handleSubmit(e) {
      e.preventDefault();
      this.form.errors = this.validateData(this.form.data);
      if (this.validateCheckbox()){
        this.form.data.checkbox.value = "yes";
      }
      if (!this.isErrors(this.form.errors)) {        
        try {
          // const res = await axios.post("http://192.168.0.109/phpmail.php", {
          const res = await axios.post("/mailchimpWebinar.php", {            
            name: this.form.data.name.value,
            lastname: this.form.data.lastname.value,
            email: this.form.data.email.value,
            company: this.form.data.company.value,
            title: this.form.data.title.value,
            country: this.form.data.country.value,
            nemployees: this.form.data.nemployees.value,
            checkbox: this.form.data.checkbox.value,
            listID: this.content.list_id
          }) 
          // console.log(res)
          if (res && res.data && res.data.status !== 400) {
            this.form.data.email.value = "";
            this.success = true;
            this.error = false;
          } else {
            this.form.data.email.value= "";
            this.success = false;
            this.error = "You are already registered.";
          }
        } catch (error) {
          this.email = "";
          this.success = false;
          this.error = "A problem occurred. Please try again later.";
        }
      }
    },
    isErrors(errors) {
      return Object.keys(errors).filter(key => errors[key] !== null).length > 0;
    },
    validateCheckbox() {
      if (document.getElementById('check').checked) {
        // this.checkbox_error = null;
        return true;
      }else{
        return false;
      }      
    },
    validateData(data) {      
      return Object.keys(data)
        .map(key => {
          if (data[key].required) {
            if (data[key].value.length < 2) {
              return { [key]: "Field is required" };
            } else if (
              key === "email" &&
              !this.validateEmail(data[key].value)
            ) {
              return { [key]: "Incorrect email address" };
            }
          } else {
            if (
              key === "phone" &&
              data[key].value.length > 0 &&
              !this.validatePhone(data[key].value)
            ) {
              return { [key]: "Incorrect phone number" };
            }
          }
          return { [key]: null };
        })
        .reduce((error, object) => ({ ...object, ...error }), {});
    }
  },
 
};
</script>

<style lang="scss">
// .register-form {
//   position: relative;
//   text-align: right;
//   margin: 0px!important;
//   padding: 0;
//   width: 100%!important;
// }
// .form-wrapper {
//   // position: relative;
//   // background: $white;
//   // padding-bottom: 50px;
//   // padding-top: 50px;
//     display: inline-block;
//     // padding: 100px;
//     max-width: calc(65% + 100px);
//     text-align: left;
//     position: relative;
//     z-index: 1;
// }


.register-form-parent {
  position: relative;
  text-align: right;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 10%;
    height: 100%;
    // background: rgba(184, 184, 184, 0.2);
  }
  .form-wrapper {
    display: inline-block;
    padding: 100px;
    max-width: calc(65% + 100px);
    text-align: left;
    position: relative;
    z-index: 1;
    .webinar-info-text {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 388px;
      text-align: center;
      // max-width: calc(65% + 100px);
      &.error {
        .info {
          color: $red;
        }
      }
      .info {
        font-size: 18px;
        line-height: 24px;
      }
    }
    .form-p-1{
      text-transform: uppercase;
      text-align: center;
      font-size: 24px;
    }
    .register-form {
      // max-width: 660px;
      margin: 0 auto;
      overflow: hidden;  
      .small-notice{
        font-size: 12px;
      }
      .checkbox-wrapper{
        // margin-bottom: 35px;
        display: block;
        position: relative;
        &.error {
          .input-checkbox{      
            #check + label {         
              border: 1px solid red;
            }
          }
        }
        .error-text {
            @include opensans-light;
            position: absolute;
            left: 0;
            bottom: 0;
            top: 28px;
            font-size: 14px;
            color: $red;
        }     
        p{
          display: inline-block;
          width: 90%;
          padding-left: 10px;
        }
        .input-checkbox{
          margin-top: 2px;
          display: block;
          width: 20px;
          height: 20px;
          float: left;   
          input#check {
            display: none;
            position: absolute;
            opacity: 0;  
            width: 20px; 
            height: 20px;
            &:checked + label svg path {
              stroke-dashoffset: 0;            
            }
            &:checked + label  {
              border: 1px solid $pink;
            }        
          }
          #check + label {         
            display: block;
            width: 80%;
            border: 1px solid rgb(189, 189, 189);
            width: 20px; 
            height: 20px;
            cursor: pointer;
            transition: border 0.3s;
            &:active {
              border: 1px solid rgb(124, 52, 52);
            }
            &:hover{
              border: 1px solid $pink;
            }
            svg {
              pointer-events: none;
              path {			
                fill: none;			
                stroke: $pink;
                stroke-width: 5px;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-dasharray: 70;
                stroke-dashoffset: 71;
                transition: all 300ms cubic-bezier(1,0,.37,.91);
              }
            }
          }
        }
      }
      input {
        display: block;
        background: none;
        border: none;
        color: $white;
        border-radius: 0;
      }
      .inputs {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -10px;
        margin-bottom: 20px;
        .input {
          position: relative;
          width: 100%;
          max-width: 100%;
          margin: 0 10px;
          padding-bottom: 15px;
          &.full {
            max-width: 100%;
          }
          &.error {
            input[type="text"],
            input[type="number"],
            textarea {
              border-bottom: 1px solid $red;
            }
          }
          input[type="text"],
          input[type="number"],
          textarea {
            @include opensans-light;
            font-size: 16px;
            line-height: 20px;
            border: none;
            border-bottom: 1px solid rgb(189, 189, 189);
            padding: 10px 0;
            width: 100%;
            transition: all 0.3s;
            background: none;
            resize: none;
            color: $white;
            border-radius: 0;
            color: black;
          }
          .error-text {
            @include opensans-light;
            position: absolute;
            left: 0;
            bottom: 0;
            font-size: 14px;
            color: $red;
          }
        }
      }
      .submit-input {
        display: flex;
        align-items: center;
        justify-content: center;//flex-end;
        // background-color: red;
        margin-top: 50px;
        &:before {
          content: "";
          width: 25px;
          height: 1px;
          background-color: $black;
          margin-right: 20px;
          transition: all 0.3s;
        }
        input[type="submit"] {
          @include josefinsans-light;
          font-size: 24px;
          line-height: 30px;
          text-transform: uppercase;
          cursor: pointer;
          color: $black;
          background-image: linear-gradient(currentColor, currentColor);
          background-position: 0% 100%;
          background-repeat: no-repeat;
          background-size: 0% 2px;
          transition: all 0.3s;
        }
        &:hover {
          &:before {
            background-color: $pink;
          }
          input[type="submit"] {
            color: $pink;
            background-size: 100% 2px;
          }
        }
      }
    }
  }
}



@media (max-width: $tablet) {
  .register-form-parent {
    text-align: center;
    .form-wrapper {
      padding: 100px 50px;
      max-width: calc(65% + 50px);
    }
    &:before {
      display: none;
    }
  }
}
@media (max-width: $mobile) {
  .register-form-parent {
    .form-wrapper {
      max-width: 90%;
      padding: 50px 0;
    }
  }
  .small-notice{
    font-size: 10px;
  }
  .checkbox-wrapper{    
    .error-text {     
        margin-top: 12px;
    }    
  }
}
</style>